import React, {useRef} from "react";
import {LinkForm} from "../../modules/LinkForm";
import {Card, CardHeader} from "../../../../_metronic/_partials/controls";

export function CreateLinkContainer() {

  const footerRef = useRef();

  return (
    <Card className="flex-grow-1">
      <CardHeader>
        <div className="py-5">
          <h3 className="mb-1 font-size-h4">판매 링크 등록</h3>
          <p className="my-0 text-muted">링크를 생성하고, 쉽고 빠르게 상품을 판매해보세요.</p>
        </div>
      </CardHeader>

      <LinkForm footerRef={footerRef} />
    </Card>
  );
}
